import React from 'react';
import { BarChart } from '@mui/x-charts';
import { Box, Typography } from "@mui/material";

const StackedBarChart = ({
  data,
  series,
  xAxisKey,
  xAxisLabel = '',
  yAxisLabel = '',
  title = '',
  height = 243,
  sx = {},
}) => (
  <Box sx={{
    width: "100%",
    boxSizing: "border-box",
    padding: "24px",
    background: "#fff",
    border: "1px solid #E5E5E5",
    borderRadius:"8px",
    ...sx
  }}>
    {title && (
      <Typography variant="h6" component="h4" sx={{ fontSize: '20px', fontWeight: 700, color: '#111', mb: 2 }}>
        {title}
      </Typography>
    )}
    {
      data?.length > 0 ? (
    <BarChart
    
      series={series}
      xAxis={[
        {
         
          dataKey: xAxisKey,
          label:xAxisLabel,
          valueFormatter: (value,context) =>{
            if(context.location === "tick"){
              return  value.length > 0 ? " " : value;
            }
             return value.charAt(0).toUpperCase() + value.slice(1).replaceAll("_"," ")
                  
          }
        },
      ]}
      yAxis={[
        {
          label: yAxisLabel,
        },
      ]}
      dataset={data}
      height={height}
      sx={{
        '& .MuiChartsAxis-root .MuiChartsAxis-line': { stroke: 'var(--grey-CCC)' },
        '& .MuiYAxis-root .MuiYAxis-line': { stroke: 'var(--grey-CCC)' },
        '& .MuiChartsAxis-root .MuiChartsAxis-tick': {stroke: 'var(--grey-CCC)' }
      }}
      slotProps={{
        legend: {
          sx: {
              width: '100%',
              marginLeft: "30px",
              height: "40px",
              marginBottom: '20px',
              flexDirection: 'column',
              overflowX: 'auto',
              textTransform:'capitalize'
          },
        },
      }}
    />
    ):(
      <div style={{display:'flex',justifyContent:'center'}}>No data to display</div>
    )
    }
  </Box>
);

export default StackedBarChart;